import React from "react"
import { micro } from "../../assets"

export const navLinks = [
  {
    name: "que fait georges ?",
    to: "/",
    onlyMobile: true,
  },
  {
    name: "que pense georges ?",
    to: "/?que-pense-georges",
    onlyMobile: true,
  },
  {
    name: "équipe",
    to: "/qui-est-georges",
    onlyMobile: false,
  },
  // {
  //   name: "projets",
  //   to: "/projets",
  //   onlyMobile: false,
  // },
  {
    name: "recherches",
    to: "/recherches",
    onlyMobile: false,
  },
  // {
  //   name: (
  //     <>
  //       <img src={micro} alt="micro" />
  //       radiogeorges
  //     </>
  //   ),
  //   to: "/radiogeorges",
  //   onlyMobile: false,
  // },
]
